import Featured from './Featured';
export default Featured;
